export const AuditName = {
    CONTACT: 'CONTACT',
    ACCOUNT: 'ACCOUNT',
    PRODUCT: 'PRODUCT',
};
